import type { StatsModel } from "./StatsModel";
import type {
  ExcursionsStats,
  PeriodStats,
  TrainingStats,
  StatsHandler,
  StatDate,
  InstructorStat,
  StatsDateRange,
  StatsGranularity,
} from "./Stats.typed";

export class StatsAdapter {
  constructor(private model: StatsModel) {}
  async getExcursionsStatsByYear(date: StatsHandler): Promise<ExcursionsStats[] | undefined> {
    return this.model.getExcursionsStatsByYear(date);
  }
  async getExcursionsStatsByMonth(date: StatsHandler): Promise<ExcursionsStats> {
    return this.model.getExcursionsStatsByMonth(date);
  }
  async getPeriodStats(
    granularity: StatsGranularity,
    range: StatsDateRange,
  ): Promise<PeriodStats[]> {
    return this.model.getPeriodStats(granularity, range);
  }
  async getStatDates(): Promise<StatDate[]> {
    return this.model.getStatDates();
  }
  async getTrainingStatsByYear(date: StatsHandler): Promise<TrainingStats[]> {
    return this.model.getTrainingStatsByYear(date);
  }
  async getInstructorStats(
    range: StatsDateRange,
    instructorId?: number,
  ): Promise<InstructorStat[]> {
    return this.model.getInstructorStats(range, instructorId);
  }
}
